
define('text!features/overlayGameLauncher/stats/xp/xpViewSmall.html',[],function () { return '<div data-bind="css: cssBinding">\n    <span class="icon icon-24 icons-avatar"></span> {{xp}}%\n</div>\n';});

